module.exports = __webpack_public_path__ + "static/media/vn.55421cd5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/vn.svg
// module id = 2242
// module chunks = 0